import { Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core"
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { formatDinero } from "../../../../../utils/formatDinero"
import { obtenerExtrasDisponiblesAction, addItemsAction, addExtraAction } from "../../../../../ducks/cotizadorPaqueteDuck"
import { catTipoItem } from "../../../../../constant/catTipoItem"
import useAPI from "../../../../../hooks/useAPI"
const FieldExtras = ({ idCategoriaExtra, label }) => {
    const { listaExtrasDisponibles, paquete, cantidadPasajeros, listaItems, extra, clavePaquete } = useSelector(store => store.cotizadorPaquete)
    const dispatch = useDispatch()
    const [valueExtra, setValueExtra] = useState(0)
    //* Metodo para obtener el catalogo de extras y sus detalles
    const catalogoExtas = useAPI(`Package/Extra/Catalog/Quotation/${clavePaquete}/${idCategoriaExtra}`)
    useEffect(() => {
        dispatch(obtenerExtrasDisponiblesAction({ categoriaExtra: idCategoriaExtra, ClavePaquete: clavePaquete }))
    }, [dispatch, idCategoriaExtra, clavePaquete])
    const handleChangeSelectValue = (event) => {
        const newExtra = event.target.value
        const extraFind = catalogoExtas.find(extraItem => extraItem.EnvioSuplementoProveedor?.IdObjeto === newExtra)
        if (!extraFind)
            return null
        let arraItems = listaItems.filter(item => item.id !== newExtra)
        let itemExtra = {
            id: extraFind.EnvioSuplementoProveedor?.IdObjeto,
            name: `${extraFind.Extra?.Nombre}`,
            price: extraFind.Suplemento,
            currency: paquete.Moneda?.Clave,
            type: catTipoItem.EXTRA,
            quantity: cantidadPasajeros,
            description: extraFind.Extra?.Descripcion
        }
        arraItems.push(itemExtra)
        setValueExtra(newExtra)
        // dispatch(addExtraAction({ extra: newExtra }))
        dispatch(addItemsAction({ listaItem: arraItems }))
    }

    return <div style={{ margin: "2% 0" }}>
        <Grid container>
            <Grid item xs={12}>
                <FormControl variant="outlined" style={{ width: "98%" }}>
                    <InputLabel id="lExtras">{label}</InputLabel>
                    <Select
                        labelId="lExtras"
                        id="SExtra"
                        name="SExtra"
                        onChange={handleChangeSelectValue}
                        label={label}
                        value={valueExtra}
                        disabled={(catalogoExtas.length == 0)}
                    >
                        <MenuItem value="0" disabled>
                            {"Seleccione una opción"}
                        </MenuItem>
                        {catalogoExtas.map((extra, index) => (
                            <MenuItem key={extra.EnvioSuplementoProveedor?.IdObjeto} value={`${extra.EnvioSuplementoProveedor?.IdObjeto}`}>
                                {`${extra.Extra?.Nombre} (${formatDinero(extra.Suplemento)} ${extra.Paquete?.Moneda?.Clave})`}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    </div>
}
export default FieldExtras